import { gql } from '@apollo/client';

const userPreferences = gql`
  mutation userPreferences($input: UserPreferencesInput!) {
    userPreferences(input: $input) {
      successful
      message
      code
    }
  }
`;

export default userPreferences;
